import { useEffect } from "react";
import { currentTimeCacheKey } from "../utils";
import { useVideoPlayer2 } from "./use-video-player-2-setup-start";

export function useVideoPlayer2Init() {
  const player = useVideoPlayer2();

  useEffect(() => {
    if (!player.videoRef.current) return;

    const video = player.videoRef.current;

    video.addEventListener("loadedmetadata", () => {
      const currentTime = window.localStorage.getItem(
        currentTimeCacheKey(player),
      );

      if (currentTime && player.props?.saveCurrentTime) {
        const savedTime = parseFloat(currentTime);
        const videoDuration = video.duration || 0;
        
        // Only restore if the saved time is valid and not at the end
        if (savedTime > 0 && savedTime < videoDuration - 1) {
          console.log(`Restoring video to ${savedTime.toFixed(2)}s (duration: ${videoDuration.toFixed(2)}s)`);
          video.currentTime = savedTime;
        } else {
          console.log(`Not restoring time: saved=${savedTime.toFixed(2)}s, duration=${videoDuration.toFixed(2)}s`);
        }
      }

      player.triggerEvent("ready", player);
    });
  }, [player]);
}
